<template>
    <div>
        <card-header title="Pending Payment Plans" icon="fa-timer"/>

        <card-body>
            <card-list>
                <subheader-list-item title="Pending Plans" icon="fa-history" :badge="pendingPlans.length"/>
                <plan-tile
                    v-for="plan in pendingPlans"
                    :key="plan.id"
                    :card="card"
                    :plan="plan"
                    :active="child && child.definition.component === 'reseller-plan-detail' && parseInt(child.props.planId) === plan.id"
                    @click="$openCard('reseller-plan-detail', {planId: plan.id}, card)"
                />
                <container-list-item v-if="pendingPlans.length === 0" padded>
                    <div class="has-text-centered has-text-grey">
                        <i class="fad fa-inbox fa-3x mb-3"></i>
                        <p>No pending payment plans found.</p>
                    </div>
                </container-list-item>
            </card-list>
        </card-body>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardList from "@/TIER/components/CardList";
    import SubheaderListItem from "@/TIER/components/SubheaderListItem";
    import ContainerListItem from "@/TIER/components/ContainerListItem";
    import PlanTile from "@/components/tiles/PlanTile";

    import {client as http} from '../../http_client';

    export default {
        components: {PlanTile, ContainerListItem, SubheaderListItem, CardList, CardBody, CardHeader},
        props: ['card', 'child'],
        data() {
            return {
                pendingPlans: []
            }
        },
        methods: {
            loadPlans: function (force) {
                this.$emit('loading', true);

                http.get('payment-plans/reseller/pending', {force}).then(response => {
                    this.pendingPlans = response.data;
                    this.$emit('loading', false);
                }, err => {
                    console.log(err);
                    this.$emit('loading', false);
                });
            },
            reload: function () {
                console.log('Reloading reseller plans...');
                this.loadPlans(true);
            }
        },
        mounted: function () {
            this.loadPlans();
        }
    }
</script>
